export const FallbackCardPaymentErrorMessage = {
  FailedToPayment: 'Failed to payment',
};
